import React from 'react';

import { useQuery, gql } from '@apollo/client';
import { Spinner } from 'equasion-lib';
import ScannedDetails from './ScannedDetails';
import ApiError from '@/lib/shared-coms/ApiError';
import { useRootStore } from '@/lib/providers/RootProvider';

const SERIALIZED_ITEM_STATE = gql`
  query serializedItemState($serialNumber: String!, $gtin: String, $companyId: ID!) {
    serializedItemState(serialNumber: $serialNumber, gtin: $gtin, companyId: $companyId) {
      purchaseOrder {
        id
        clientPurchaseOrderNumber
        vendor {
          id
          companyName
          billingAddress {
            lineOne
            lineTwo
            city
            state
            zipCode
            countryCode
          }
        }
      }
      pedigree {
        SSCC
        CA
        PK
        ITEM
      }
    }
    inventoryEventHistory(
      serialNumber: $serialNumber
      gtin: $gtin
      companyId: $companyId
    ) {
      id
      type
      createdAt
      user {
        id
        name
      }
    }
  }
`;

const ScannedDetailsData = ({ serialNumber, gtin, ...props }) => {
  const selectedCompanyId = useRootStore((state) => state.selectedCompany?.id);
  const { data, error, loading } = useQuery(SERIALIZED_ITEM_STATE, {
    variables: { serialNumber, gtin, companyId: selectedCompanyId }
  });

  if (loading) return <Spinner />;
  if (error) return <ApiError error={error} />;

  const {
    serializedItemState: { purchaseOrder, pedigree },
    inventoryEventHistory
  } = data || {};

  return (
    <ScannedDetails
      purchaseOrder={purchaseOrder}
      pedigree={pedigree}
      serialNumber={serialNumber}
      inventoryEventHistory={inventoryEventHistory}
      {...props}
    />
  );
};

export default ScannedDetailsData;
